import type { DemoKey } from '../types';

export const ta: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'கணிதம் · புள்ளியியல்',
  'app.title': 'புள்ளியியல்',
  'panel.experiment': 'காட்சி',
  'panel.params': 'அளவுருக்கள்',

  'exp.survey-explorer.title': 'ஆய்வு ஆராயி',
  'exp.survey-explorer.desc':
    'ஒரு பத்தியைத் தேர்வு செய்; டெமோ பொருத்தமான சுருக்கத்தைத் தேர்ந்தெடுக்கும்.',
  'exp.distribution-sculptor.title': 'பரவல் சிற்பி',
  'exp.distribution-sculptor.desc': 'புள்ளிகளை இழுத்து புள்ளியியல் மாற்றத்தைப் பார்.',
  'exp.two-variable-lab.title': 'இரண்டு மாறி ஆய்வகம்',
  'exp.two-variable-lab.desc': 'சிதறல், பொருத்தம், காரண-கேள்வி.',
  'exp.sampling-lab.title': 'மாதிரியாய்வகம்',
  'exp.sampling-lab.desc': 'நுட்பமும் அளவும் மாதிரி சராசரியை எப்படி நகர்த்துகிறது.',
  'exp.probability-diagrams.title': 'நிகழ்தகவு வரைபடம்',
  'exp.probability-diagrams.desc': 'கூட்டு நிகழ்வுகளுக்கு வென் மற்றும் மர காட்சி.',

  'type.qualitative-nominal.label': 'பண்பு · பெயரளவு',
  'type.qualitative-nominal.def': 'வரிசை இல்லாத பிரிவுகள்.',
  'type.qualitative-ordinal.label': 'பண்பு · வரிசை',
  'type.qualitative-ordinal.def': 'பொருளுள்ள வரிசையுடைய பிரிவுகள்.',
  'type.qualitative-multi.label': 'பண்பு · பல மதிப்பு',
  'type.qualitative-multi.def': 'ஒவ்வொரு கண்காணிப்புக்கும் பல குறி.',
  'type.quantitative-discrete.label': 'அளவீடு · துண்டான',
  'type.quantitative-discrete.def': 'நிலையான படிகளில் எண்கள்.',
  'type.quantitative-continuous.label': 'அளவீடு · தொடர்ச்சி',
  'type.quantitative-continuous.def': 'தொடர் அளவில் அளக்கப்பட்ட எண்கள்.',

  'column.name.label': 'மாணவன் பெயர்',
  'column.height_cm.label': 'உயரம்',
  'column.shoe_size_eu.label': 'காலணி அளவு (EU)',
  'column.study_hours.label': 'வாரம் / படிப்பு நேரம்',
  'column.test_score.label': 'தேர்வு மதிப்பெண்',
  'column.sports_played.label': 'விளையாட்டுகள்',
  'column.eye_color.label': 'கண் நிறம்',
  'column.commute_min.label': 'பயணம்',
  'column.grade_year.label': 'வகுப்பு',
  'column.homework_effort.label': 'வீட்டுப்பாடம் முயற்சி',
  'column.ice-cream-sales.label': 'ஐஸ்க்ரீம் விற்பனை',
  'column.drownings.label': 'மூழ்கல்கள்',
  'column.month.label': 'மாதம்',
  'column.storks.label': 'நாரைகள்',
  'column.births.label': 'பிறப்புகள்',
  'column.country_area_km2.label': 'நாட்டின் பரப்பு',
  'column.sleep_hours.label': 'தூக்கம் மணி',
  'column.reaction_ms.label': 'பதில் நேரம்',

  'dataset.master-survey.label': 'வகுப்பு ஆய்வு',
  'dataset.master-survey.desc': '30 உருவகப்படுத்திய மாணவர்கள்.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'ஐஸ்க்ரீம் vs மூழ்கல்',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'இரண்டும் பருவத்துடன் ஏறி இறங்கும். மூழ்கல் ஐஸ்க்ரீம் விற்பனைக்கு காரணம் இல்லை.',
  'dataset.spurious-storks-vs-births.label': 'நாரை vs பிறப்பு',
  'dataset.spurious-storks-vs-births.desc':
    'பெரிய நாடுகளில் அதிக நாரைகள், அதிக பிறப்புகள். பறவைகள் காரணமல்ல.',
  'dataset.real-sleep-vs-reaction-time.label': 'தூக்கம் vs பதில் நேரம்',
  'dataset.real-sleep-vs-reaction-time.desc':
    'அதிக தூக்கம், வேக பதில். உண்மையான எதிர் தொடர்பு — இயற்கைக் காரணம் உண்டு.',

  'tag.football.label': 'காற்பந்து',
  'tag.basketball.label': 'கூடைப்பந்து',
  'tag.volleyball.label': 'கைப்பந்து',
  'tag.swimming.label': 'நீச்சல்',
  'tag.none.label': 'இல்லை',

  'population.gaussian.label': 'மணி வடிவம்',
  'population.right-skewed.label': 'வலதுபக்க வளைவு',
  'population.bimodal.label': 'இரு உச்சம்',
  'population.uniform.label': 'சீரான',

  'venn.dice-even-or-prime.label': 'பகடை: இரட்டை அல்லது பகா',
  'venn.class-sports-2set.label': 'விளையாட்டு (2 கணம்)',
  'venn.class-sports-3set.label': 'விளையாட்டு (3 கணம்)',
  'venn.custom.label': 'தனிப்பயன்',

  'tree.draw-without-replacement.label': 'மாற்றமின்றி',
  'tree.custom.label': 'தனிப்பயன்',
  'tree.coin.heads': 'ஹெ',
  'tree.coin.tails': 'டெ',
  'tree.draw.start': 'பை: 2 சிவப்பு, 3 நீலம்',
  'tree.draw.red': 'சிவப்பு',
  'tree.draw.blue': 'நீலம்',
  'tree.custom.start': 'தொடக்கம்',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'நிகழ்வுச்சட்டம்',
  'card.cumulative': 'சேர் நிகழ்வு',
  'card.box': 'பெட்டி வரைபடம்',
  'card.summary': '5-எண் சுருக்கம்',
  'card.bar': 'பட்டை வரைபடம்',
  'card.mode': 'பெருங்கூடு',
  'card.tag-frequency': 'குறி நிகழ்வு',
  'card.mode-tag': 'மிக அதிக குறி',
  'card.empty-no-order': 'பொருந்தாது',
  'card.empty-multi': 'பொருந்தாது',
  'card.numberline': 'எண் கோடு',
  'card.scatter': 'சிதறல்',
  'card.description': 'என்ன நடக்கிறது',
  'card.population': 'மக்கள்தொகை',
  'card.sampling-distribution': 'மாதிரி சராசரி',
  'card.venn': 'வென்',
  'card.tree': 'மரம்',
  'card.probabilities': 'நிகழ்தகவுகள்',

  'param.dataset.label': 'தரவுத் தொகுப்பு',
  'param.column.label': 'பத்தி',
  'param.bins.label': 'பெட்டிகள்',
  'param.shape.label': 'ஆரம்ப வடிவம்',
  'param.show-mean.label': 'சராசரி காட்டு',
  'param.show-median.label': 'நடுவன் காட்டு',
  'param.x-col.label': 'X பத்தி',
  'param.y-col.label': 'Y பத்தி',
  'param.show-regression.label': 'அடர்வரை',
  'param.show-residuals.label': 'மீதிகள்',
  'param.show-confounder.label': 'குழப்பி காட்டு',
  'param.population.label': 'மக்கள்தொகை',
  'param.technique.label': 'நுட்பம்',
  'param.sample-size.label': 'மாதிரி அளவு',
  'param.stratum.label': 'அடுக்கு',
  'param.bias.label': 'சார்பு',
  'param.mode.label': 'பயன்முறை',
  'param.preset.label': 'முன்னமைப்பு',
  'param.universe.label': 'அண்ட அளவு',
  'param.show-prob.label': 'நிகழ்தகவுகள் காட்டு',
  'param.treat-as-numeric.label': 'எண்ணாகக் கொள்',

  'stat.count': 'எண்ணிக்கை',
  'stat.mean': 'சராசரி',
  'stat.median': 'நடுவன்',
  'stat.range': 'விரிவு',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'விலகியவை',
  'stat.r': 'பீர்சன் r',
  'stat.r2': 'r²',
  'stat.slope': 'சாய்வு',
  'stat.intercept': 'வெட்டு',
  'stat.n': 'n',
  'stat.population-mean': 'உண்மை சராசரி',
  'stat.latest-sample-mean': 'மாதிரி சராசரி',
  'stat.sample-mean-spread': 'மாதிரி சராசரி SD',
  'stat.sample-count': 'எடுத்த மாதிரிகள்',
  'outlier.upper': 'மேல் விலகியவை',
  'outlier.lower': 'கீழ் விலகியவை',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'மீள் மாதிரி',
  'btn.run-100': '100 மாதிரி எடு',
  'btn.stop': 'நிறுத்து',
  'btn.clear-history': 'வரலாறு நீக்கு',

  'explainer.no-order': 'வரிசை இல்லை → சேர் இல்லை, பெட்டி இல்லை.',
  'explainer.multi-no-iqr': 'பல மதிப்பு → கால்வாசிகள் / IQR வரையறுக்கப்படவில்லை.',
  'message.no-data': 'தரவில்லை.',
  'message.needs-quartiles': 'கால்வாசிகளுக்கு ≥4 புள்ளி தேவை.',
  'message.x-zero-variance': 'X-இன் மாறுபாடு பூஜ்யம் — பொருத்த கோடு இல்லை.',
  'message.n-too-small': 'n மிகச் சிறியது.',
  'message.stratum-clamp':
    'அடுக்கில் கேட்டதைக் காட்டிலும் குறைவான வரிசைகள் — அனைத்தும் பயன்படுத்தப்பட்டன.',
  'message.siblings-sum-to-one': 'உடன்பிறந்தவர் மொத்தம் 1 ஆக இருக்க வேண்டும்.',
};
